import React from "react"
import PropTypes from 'prop-types'
import { Layout, Menu, Divider, Dropdown } from 'antd'

import { Link } from "react-router-dom"

import { UserOutlined, DesktopOutlined, LayoutOutlined, DeploymentUnitOutlined, ReadOutlined } from '@ant-design/icons'

import { deleteToken } from "@/utils"

import styles from "./Layout.module.css"

const { SubMenu } = Menu
const { Header, Content, Sider } = Layout


function CommonLayout(props) {

    const logout = () => {
        deleteToken()
        window.location.reload()
    }

    const renderUserPanel = () => {

        const menu = (
            <Menu style={{ textAlign: "center" }}>
                <Menu.Item onClick={() => logout()}>退出登录</Menu.Item>
            </Menu>
        );

        return (
            <span style={{ color: "white", fontSize: 16 }}>
                <Dropdown overlay={menu}>
                    <span className={styles.userName}>
                        <UserOutlined style={{ marginRight: 4 }} />
                        <span>超级管理员</span>
                    </span>
                </Dropdown>
            </span>
        )
    }

    return (
        <Layout style={{ height: "100%", minWidth: "1200px", "overflow": "auto" }}>
            <Header className={styles.header}>
                <div className={styles.left}>
                    <Link to="/" className={styles.logo}>
                        Jowo Studio后台管理系统
                </Link>
                </div>
                <div className={styles.right}>
                    {renderUserPanel()}
                </div>
            </Header>
            <Layout>
                <Sider width={200} className="site-layout-background">
                    <Menu
                        mode="inline"
                        defaultSelectedKeys={[props.selectedMenuKey]}
                        defaultOpenKeys={props.openMenuKeys}
                        selectable={false}
                        style={{ height: '100%', borderRight: 0 }}
                    >
                        <Menu.Item key="user" icon={<UserOutlined />}>
                            <Link to="/users">用户管理</Link>
                        </Menu.Item>

                        <SubMenu key="groupSite" icon={<LayoutOutlined />} title="模板管理">
                            <Menu.Item key="collectionSites">
                                <Link to="/collectionSites">模板库</Link>
                            </Menu.Item>
                            <Menu.Item key="sellingSites">
                                <Link to="/sellingSites">精选模板</Link>
                            </Menu.Item>
                            <Menu.Item key="sellingSiteDevices">
                                <Link to="/sellingSites/devices">设备</Link>
                            </Menu.Item>
                            <Menu.Item key="sellingSiteTags">
                                <Link to="/sellingSites/tags">场景</Link>
                            </Menu.Item>
                        </SubMenu>

                        <SubMenu key="groupPublicComponents" icon={<DeploymentUnitOutlined />} title="组件管理">
                            <Menu.Item key="publicComponentsPackages">
                                <Link to="/publicComponents/packages">组件代码包</Link>
                            </Menu.Item>
                            <Menu.Item key="publicComponentsGroups">
                                <Link to="/publicComponents/groups">组件分组</Link>
                            </Menu.Item>
                        </SubMenu>
                    </Menu>
                </Sider>
                <Layout style={{ padding: '0 24px 24px' }}>
                    <Content
                        className="site-layout-background"
                        style={{
                            padding: 24,
                            margin: 0,
                            minHeight: 280,
                        }}
                    >
                        {props.children}
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    )

}

CommonLayout.propTypes = {
    selectedMenuKey: PropTypes.string,
    openMenuKeys: PropTypes.array.isRequired
}

CommonLayout.defaultProps = {
    selectedMenuKey: "",
    openMenuKeys: []
}

export default CommonLayout